import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum CurrentDrawerOpenType {
    AddObject = "addObject",
    EditObject = "editObject",
    EditRoom = "editRoom",
    BSUObject = "bsuObject",
    Null = "null",
    Stack = "stack",
    Trolley = "trolley",
    Anesthesia = "anesthesia",
    Surgeon = "surgeon",
    Slave = "slave",
    Port = "port",
    Console = "console",
    AccessPoint = "AccessPoint",
    Bed = "Bed",
}

export type RightDrawerType = {
    isModelOpen: boolean;
    modelTitle: string;
    type: CurrentDrawerOpenType;
};

const initialState = {
    isModelOpen: false,
    modelTitle: "Add new",
    type: CurrentDrawerOpenType.AddObject,
} as RightDrawerType;

const RightDrawerSlice = createSlice({
    name: "rightDrawer",
    initialState: initialState,
    reducers: {
        toggleDrawer: (state, action: PayloadAction<CurrentDrawerOpenType>) => {
            const nextDrawer = action.payload;

            if (state.isModelOpen && state.type === nextDrawer) {
                state.isModelOpen = false;
                return;
            }

            state.type = nextDrawer;
            state.isModelOpen = true;
        },
        closeDrawer: (state, action: PayloadAction<CurrentDrawerOpenType>) => {
            state.isModelOpen = false;
            state.type = action.payload;
        },
        updateDrawerTitle: (state, action: PayloadAction<string>) => {
            state.modelTitle = action.payload;
        },
        updateCurrentDrawerOpenType: (state, action: PayloadAction<CurrentDrawerOpenType>) => {
            state.type = action.payload;
        },
        hideDrawer: (state) => {
            state.isModelOpen = false;
        },
    },
});

export const {
    toggleDrawer,
    hideDrawer,
    updateDrawerTitle,
    updateCurrentDrawerOpenType,
    closeDrawer,
} = RightDrawerSlice.actions;

export default RightDrawerSlice.reducer;
